import clsx from "clsx";
import { createElement, type HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Ground: --bg-elevated, or the tinted surface (--bg-elevated on dark, #ECEDEF on light). */
  tone?: "card" | "tinted";
  /** 16 px padding instead of 24 px. */
  dense?: boolean;
  as?: "div" | "section" | "article" | "li";
}

/**
 * Card per 10_component-anatomy.md section 2: radius-md, 24 px padding, and a --border-strong
 * edge, because no ground identifies a card by fill (the dark elevated surface is 1.17:1 against
 * the canvas; Clinic White 1.06:1 against Paper). No shadow is needed for structure. There is no
 * inverse tone: a ground is forced with data-theme, not an inverse surface.
 */
export function Card({ tone = "card", dense = false, as = "div", className, ...rest }: CardProps) {
  return createElement(as, {
    ...rest,
    className: clsx("rounded-md border border-rule-strong", dense ? "p-4" : "p-6", tone === "card" ? "bg-card" : "bg-card-tinted", className),
  });
}
